import { Bolt } from './Icons';

export default function Footer({ company }) {
  const c = company.contact || {};
  const year = new Date().getFullYear();
  return (
    <footer className="footer">
      <div className="container footer__inner">
        <div className="footer__brand">
          <span className="nav__mark">
            <Bolt width={18} height={18} />
          </span>
          <div>
            <strong>{company.name}</strong>
            <p>{company.tagline}</p>
          </div>
        </div>

        <nav className="footer__links" aria-label="Footer">
          <a href="#services">Services</a>
          <a href="#tools">Digital Tools</a>
          <a href="#work">Our Work</a>
          <a href="#about">About</a>
          <a href="#contact">Contact</a>
        </nav>

        <div className="footer__contact">
          {c.phone && <a href={`tel:${c.phone.replace(/\s+/g, '')}`}>{c.phone}</a>}
          {c.email && <a href={`mailto:${c.email}`}>{c.email}</a>}
          {c.country && <span>{c.country}</span>}
        </div>
      </div>
      <div className="footer__bar">
        <span>© {year} {company.name}. All rights reserved.</span>
        {company.director && <span>Director: {company.director}</span>}
      </div>
    </footer>
  );
}
